<template>
  <!-- 系统管理员 -->
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box" :title="`${youthShortName}`">机构提交信息（{{youthShortName}}）</div>
    </template>
    <template v-slot:nav_right>
      <template v-if="!audit">
        <div v-if="isAudit" class="yioks_btn yioks_audit" @click="handleAuditTarget">
          结果确认
        </div>
      </template>
      <div
        v-if="orgAuditStageLogList.length"
        class="yioks_btn"
        @click="handleViewAuditList"
      >
        审核记录
      </div>
      <div class="yioks_btn" @click="handleDownloadAllFiles">下载全部文件</div>
      <template v-if="audit">
        <div v-if="!isAudit" class="yioks_btn" @click="handleDownloadAuditFiles">下载评估结果</div>
      </template>
      <div  class="yioks_btn" @click="getBaseScoreFile()">专家评分表</div>
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <!-- <div class="select_wrap">
            <div class="select_box left"></div>
            <div class="select_box right">
            </div>
          </div> -->

          <div class="list_wrap" v-if="!loading && !empty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th youthName">评估指标</div>
                  <div
                    class="th youthShortName"
                    :class="{ big: !isInClubSystem }"
                  >
                    评估内容
                  </div>
                    <div class="th submit">分值分配</div>
                  <template v-if="isInClubSystem">
<!--                    <div class="th audit">自评得分</div>-->
                    <!-- <div class="th auditScore">评估得分</div> -->
                    <div class="th auditScore">专家打分</div>
                  </template>
                  <template v-else>
<!--                    <div class="th auditScore">初审打分</div>-->
                    <div class="th auditScore">专家打分</div>
                  </template>
                  <div class="th action">评估材料</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in targetSubmitListVos"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td youthName double">
                          <template v-if="isInClubSystem">
                            <p
                              class="suc"
                              :title="`【${item.targetSecondlyName}】`"
                            >
                              【{{ item.targetSecondlyName }}】
                            </p>
                            <p :title="item.targetThirdlyName">
                              {{ item.targetThirdlyName }}
                            </p>
                          </template>
                          <template v-else>
                            <p class="suc" :title="`【${item.targetSecondlyName}】`">
                              【{{ item.targetSecondlyName }}】
                            </p>
                            <p :title="item.targetThirdlyName">
                              {{ item.targetThirdlyName }}
                            </p>
                          </template>
                        </div>
                        <div
                          class="td youthShortName"
                          :class="{ big: !isInClubSystem }"
                        >
                          <p :title="item.targetSecondlyRemark">
                            {{ item.targetSecondlySuggest }}
                          </p>
                        </div>
                          <div class="td submit">
                            <p>0 ~ {{ item.targetSecondlyTotalScore }}</p>
                          </div>
                        <template v-if="isInClubSystem">
<!--                          <div class="td audit">-->
<!--                            <p>{{ item.score || 0 }}</p>-->
<!--                          </div>-->
                          <div class="td auditScore">
                            <p v-if="item.expertAuditScoreUuid !== undefined && item.targetSecondlyTotalScore === 0">{{ item.qualified ? '材料不合格' : '材料合格' }}</p>
                            <p v-else-if="item.submit">{{ item.expertAuditScore | auditScoreFiler }}</p>
                            <p v-else>0</p>
                          </div>
                        </template>
                        <template v-else>
<!--                          <div class="td auditScore">-->
<!--                            <p v-if="item.orgAuditScoreUuid">{{ item.orgAuditScore }}</p>-->
<!--                            <p v-else>&#45;&#45;</p>-->
<!--                          </div>-->
                          <div class="td auditScore">
                            <p v-if="item.orgAuditScoreUuidZhuan !== undefined && item.targetSecondlyTotalScore === 0">{{ item.qualified ? '材料不合格' : '材料合格' }}</p>
                            <p v-else-if="item.orgAuditScoreUuidZhuan">{{ item.orgAuditScoreZhuan }}</p>
                            <p v-else>--</p>
                          </div>
                        </template>

                        <div class="td action">
                        <!-- v-if="isInClubSystem" -->
                        <!-- 注意，这里club版本的admin账户和区admin账户均不在有打分编辑功能 -->
<!--                          <p v-if="false" :data-autid="audit">-->
                          <p v-if="!isInClubSystem"  :data-autid="audit">
                            <template v-if="item.submit">
                              <!-- 已审核操作 -->
                              <template v-if="!audit">
                                <!--<span-->
                                  <!--class="item active"-->
                                  <!--v-if="item.adminAuditScoreUuid"-->
                                  <!--@click="handleUploadScore(item, false)"-->
                                  <!--&gt;编辑</span-->
                                <!--&gt;-->
                                <!--<span-->
                                  <!--class="item active"-->
                                  <!--v-else-->
                                  <!--@click="handleUploadScore(item, false)"-->
                                  <!--&gt;审核</span-->
                                <!--&gt;-->
                                <span
                                  class="item active"
                                  @click="handleUploadScore(item, true)"
                                >预览</span
                                >
                              </template>
                              <!-- 未审核操作 -->
                              <template v-else>
                                <span
                                  class="item active"
                                  @click="handleUploadScore(item, true)"
                                  >预览</span
                                >
                              </template>
                            </template>
                            <template v-else>
<!--                              一次性的，这次用完就删除，还原，如果下次还使用的话，就修改接口，新增字段验证，uuid为二级指标uuid-->
<!--                              <span class="item">暂无文件</span>-->
                              <template v-if="item.uuid === 'deab4d5f16b04a57a37e2559d2cbfe5d' || item.uuid === 'ec9300d241584c069384dc3a79636711'">
                                <!-- 已审核操作 -->
                                <template v-if="!audit">
                                <span
                                  class="item active"
                                  v-if="item.adminAuditScoreUuid"
                                  @click="handleUploadScore(item, false)"
                                >编辑</span
                                >
                                  <span
                                    class="item active"
                                    v-else
                                    @click="handleUploadScore(item, false)"
                                  >审核</span
                                  >
                                </template>
                                <!-- 未审核操作 -->
                                <template v-else>
                                <span
                                  class="item active"
                                  @click="handleUploadScore(item, true)"
                                >预览</span
                                >
                                </template>
                              </template>
                              <template v-else>
                                <span class="item">未提交</span>
                              </template>

                            </template>
                          </p>
                          <p v-else>
                            <span
                              class="item active"
                              v-if="item.submit"
                              @click="handleDownloadFile(item)"
                              >预览</span
                            >
                            <span class="item" v-else>暂无文件</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <template v-if="isInClubSystem">
              <div class="footer-tips">
                <!-- <span>评估进程：{{ tongji }}%</span> -->
<!--                <span style="margin-left: 40px">自评得分：{{ auditTotalScore }}</span>-->
                <!-- jixiaoScore.youthScore -->
                <!-- <span style="margin-left: 40px"
                  >评估得分：{{ adminAuditScore }}</span
                > -->
                <span style="margin-left: 40px">专家打分：{{ experAuditScore }}</span>
              </div>
            </template>
            <template v-else>
              <div class="footer-tips">
                 <span>评估进程：{{ tongji }}%</span>
<!--                <span style="margin-left: 40px">初审得分：{{ orgAuditScore }}</span>-->
                <span style="margin-left: 40px">得分：{{ ZuanAuditScore }}</span>
                <template v-if="!isAudit && auditState !== 3">
                  <template v-if="!auditResult">
                    <span class="cursor" style="margin-left: 40px" @click="handleUploadAuditResult()">上传签字确认文件</span>
                  </template>
                  <template v-else>
                    <span>
                     <a v-if="checkDownload(auditResult.auditResultFileName)"  :href="$yioksConfig.transferBaseOnly(auditResult.auditResultFileUrl)" target="_blank" class="cursor" style="margin-left: 40px" >
                       查看签字确认文件
                     </a>
                     <a v-else :href="$yioksConfig.transferBaseOnly(auditResult.auditResultFileUrl)" :download="auditResult.auditResultFileName" class="cursor" style="margin-left: 40px"  >
                       查看签字确认文件
                     </a>
                    </span>
                  </template>
                </template>
              </div>
            </template>
          </div>

          <yioks-empty v-if="empty"></yioks-empty>
          <yioks-loading v-if="loading"></yioks-loading>

          <template v-if="isShowAuditList">
            <audit-history-list
              :isShow.sync="isShowAuditList"
              :auditList="orgAuditStageLogList"
              @callback1="orgAuditCallback"
            >
            </audit-history-list>
          </template>

          <!-- 审核弹窗 -->
          <template v-if="isInClubSystem">
            <template v-if="isShowAudit">
              <org-audit-msg
                :isShow.sync="isShowAudit"
                :stageUuid="stageUuid"
                :youthUuid="youthUuid"
                :groupUuid="groupUuid"
                :auditTotalScore="experAuditScore"
                :isShowScore="true"
                :selectOptionsForDeny="selectOptionsForDeny"
                @callback="orgAuditCallback"
              >
              </org-audit-msg>
            </template>
          </template>
          <template v-else>
            <template v-if="isShowAudit">
              <org-audit-msg
                :isShow.sync="isShowAudit"
                :stageUuid="stageUuid"
                :youthUuid="youthUuid"
                :groupUuid="groupUuid"
                :auditTotalScore="ZuanAuditScore"
                :isShowScore="true"
                :selectOptionsForDeny="selectOptionsForDeny"
                @callback="orgAuditCallback"
              >
              </org-audit-msg>
            </template>
          </template>

          <!-- 下载预览 文件列表 补充信息 -->
          <template v-if="isShowDownloadList">
            <downlad-view
              :isShow.sync="isShowDownloadList"
              :configInfo="downloadViewInfo"
            >
            </downlad-view>
          </template>
          <!-- club 用文件下载，提交成绩 -->
          <template v-if="isShowUploadScore">
            <downlad-view-club
              :isShow.sync="isShowUploadScore"
              :configInfo="downloadViewInfoForClub"
              @callbackForClub="handleViewCallBackForClub"
            >
            </downlad-view-club>
          </template>

          <template v-if="isShowAdminAuditResult">
            <admin-audit-result
              :isShow.sync="isShowAdminAuditResult"
              :stageUuid="stageUuid"
              :youthUuid="youthUuid"
              @callbackForAuditResult="handleViewCallBackForAuditResult"
            >
            </admin-audit-result>
          </template>
        </div>
      </div>
    </template>
  </yioks-content>
</template>

<script>
import {
  getOrgAuditList,
  replaceAuditTarget,
  downloadMutileFile,
  getTargetFileList,
  getTargetLabelList,
  getSecondTargetFileAndLabel,
  getAllFiles,
  getAuditFiles,
  baseScoreFileList
} from "@/api/performance";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { downloadByJs } from "@/utils/commen";
import mixinAppConfig from "@/mixin/mixinAppConfig";
import storage from '@/utils/storage'

export default {
  mixins: [mixinAppConfig],
  data() {
    return {
      userRole: storage.get('userInfo').userRole,
      loading: false,
      empty: false,
      jixiaoOrgToScore: {}, // 上级评分
      targetSubmitListVos: [],
      downloastList: [], // 指标文件列表
      submitForm: {
        orgAppraise: "", // 上级评价
        orgScore: "", // 上级评分
        orgRating: "", // 上级评价等级
      },
      downloadRow: {},
      submitFormRules: {
        // orgAppraise: [requiredItem("评估结果概述")],
        orgScore: [requiredItem("评估得分"), numberRequired("评估得分")],
      },

      isShowDialogDetails: false,
      isReadOnly: false,

      isAudit: false,
      orgAuditStageLogList: [],
      isShowAuditList: false,
      auditResult: {},
      auditState: '',

      isShowAudit: false,
      isShowAdminAuditResult: false,
      isShowDownloadList: false, // 下载预览
      downloadViewInfo: {},
      selectOptionsForDeny: [],

      isShowUploadScore: false,
      downloadViewInfoForClub: {},
    };
  },

  components: {
    "audit-history-list": () => import("./components/AuditHistoryList"),
    "org-audit-msg": () => import("./components/OrganAuditDialog"),
    "admin-audit-result": () => import("./components/AdminAuditResult"),
    "downlad-view": () =>
      import("@/views/performance/downloadStageLabelsAndFiles"),
    "downlad-view-club": () =>
      import("@/views/performance/downloadStageLabelsAndFilesForClub"),
  },

  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid;
    },
    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid;
    },
    youthUuid() {
      const { youthUuid } = this.$route.query;
      return youthUuid;
    },
    youthName() {
      const { youthName } = this.$route.query;
      return youthName;
    },
    youthShortName() {
      const { youthShortName } = this.$route.query;
      return youthShortName;
    },
    audit() {
      const { audit } = this.$route.query;
      if (audit == "true") return true;
      if (audit == "false") return false;
      else return false;
    },

    // 自评得分
    auditTotalScore() {
      let auditTotalScore = 0;
      if (this.targetSubmitListVos.length) {
        this.targetSubmitListVos.forEach((item) => {
          const { score } = item;
          if (typeof score === "number") {
            auditTotalScore += score;
          }
        });
      }
      return auditTotalScore;
    },

    // 评估得分
    experAuditScore() {
      let auditTotalScore = 0;
      if (this.targetSubmitListVos.length) {
        this.targetSubmitListVos.forEach((item) => {
          const { expertAuditScore } = item;
          if (typeof expertAuditScore === "number") {
            auditTotalScore += expertAuditScore;
          }
        });
      }
      return auditTotalScore;
    },

    // 评估进度
    tongji() {
      if (this.targetSubmitListVos.length) {
        let all_submit = 0;
        const all_length = this.targetSubmitListVos.length;
        this.targetSubmitListVos.forEach((item) => {
          // if(item.auditScoreUuid) {
          if (item.orgAuditScoreUuidZhuan) {
            all_submit += 1;
          }
        });
        return ((all_submit / all_length) * 100).toFixed(0);
      } else {
        return 0;
      }
    },

    // 初审得分
    orgAuditScore() {
      let auditTotalScore = 0;
      if (this.targetSubmitListVos.length) {
        this.targetSubmitListVos.forEach((item) => {
          const { orgAuditScore } = item;
          if (typeof orgAuditScore === "number") {
            auditTotalScore += orgAuditScore;
          }
        });
      }
      return auditTotalScore;
    },

    // 终审审得分
    adminAuditScore() {
      let auditTotalScore = 0;
      if (this.targetSubmitListVos.length) {
        this.targetSubmitListVos.forEach((item) => {
          const { adminAuditScore } = item;
          if (typeof adminAuditScore === "number") {
            auditTotalScore += adminAuditScore;
          }
        });
      }
      return auditTotalScore;
    },
    // 终审审得分
    ZuanAuditScore() {
      let auditTotalScore = 0;
      if (this.targetSubmitListVos.length) {
        this.targetSubmitListVos.forEach((item) => {
          const { orgAuditScoreZhuan } = item;
          if (typeof orgAuditScoreZhuan === "number") {
            auditTotalScore += orgAuditScoreZhuan;
          }
        });
      }
      return auditTotalScore;
    },
  },

  filters: {
    auditScoreFiler(val) {
      if (val !== undefined || val === "") {
        return val;
      } else {
        return "--";
      }
    },
  },

  created() {
    this.loadPageDetails();

  },

  mounted() {
//    const source = "http://shanghaiqingxun.devzz.yioks.org:2492/uploads/jixiaoFile/AllZip/NoWaterMark/87a72980b4984119866981565e56adca/b51e5ae065434544a6d957d54bb3d6bb.zip";
    // const nowUrl = this.$yioksConfig.urlTransferToClub(source)
//    console.log('\n\n------ begin:  ------')
    // console.log('source', source)
    // console.log('nowUrl', nowUrl)
    // console.log('this.$yioksConfig.isClubApp()', this.$yioksConfig.isClubApp())
//    console.log('######', this.$yioksConfig.transferBaseOnly(source))
//    console.log('------ end:  ------\n\n')

  },

  methods: {
    getBaseScoreFile() {
      baseScoreFileList(this.youthUuid,this.stageUuid)
      .then(res => {
        if(res.code) {
          this.$message.error(res.msg);
          return
        }
        if (res && res.length) {
//          window.open(res[0].fileUrl)
          window.open('http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent(this.$Base64.encode(res[0].fileUrl)));
        }else{
          this.$message.error('专家评分表暂未上传');
        }
      })
      .catch(err => {
        this.isShowLoading = false;
        console.error('err', err)
      })
    },
    checkDownload (fileName) {
      let patten = /\.(jpg|jpeg|gif|bmp|png|pdf)$/i
      return patten.test(fileName)
    },

    handleBack() {
      this.$router.back();
    },

    // 加载页面列表信息
    loadPageDetails(flag = false) {
      const paramsData = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        youthUuid: this.youthUuid,
        targetSecondlyName: "",
      };
      if(!flag) this.loading = true;
      getOrgAuditList(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { audit, orgAuditStageLogList, targetSubmitListVos, auditResult, auditState } = res;
          if (targetSubmitListVos.length) {
            this.empty = false;
          } else {
            this.empty = true;
          }
          this.targetSubmitListVos = targetSubmitListVos;
          this.orgAuditStageLogList = orgAuditStageLogList;
          this.isAudit = audit;
          this.auditResult = auditResult;
          this.auditState = auditState;
          this.selectOptionsForDeny = targetSubmitListVos.map((item) => {
            return {
              label: item.targetThirdlyName,
              value: item.uuid,
            };
          });
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },

    // 下载全部文件
    handleDownloadAllFiles() {
      const queryData = {
        youthUuid: this.youthUuid,
        stageUuid: this.stageUuid,
      };
      getAllFiles(queryData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { fileName, filePath } = res;
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath);
          downloadByJs(transferPath, fileName);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 下载评估结果
    handleDownloadAuditFiles() {
      const queryData = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        youthUuid: this.youthUuid,
      };
      getAuditFiles(queryData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { fileName, filePath } = res;
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath);
          downloadByJs(transferPath, fileName);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 预览上传文件
    handleDownloadFile(row) {
      const { uuid, groupUuid, auditRemark,adminAuditRemark } = row;
      const paramsData = {
        targetSecondlyUuid: uuid,
        stageUuid: this.stageUuid,
        youthUuid: this.youthUuid,
        groupUuid: groupUuid,
        youthName: this.youthName,
        auditRemark: auditRemark,
        adminAuditRemark: adminAuditRemark,
      };
      this.downloadViewInfo = paramsData;
      this.isShowDownloadList = true;
    },

    // 审核该组织
    handleAuditTarget() {
      this.isShowAudit = true;
    },
    // 查看审核记录
    handleViewAuditList() {
      this.isShowAuditList = true;
    },
    // 审核弹窗 callback function
    orgAuditCallback(status) {
      if (status) {
        this.$router.back();
      }
    },
    handleUploadScore(row, isDisabled) {
      const {
        targetSecondlyTotalScore,
        scoreUuid,
        adminAuditScore,
        adminAuditScoreUuid,
        uuid,
        groupUuid,
        score,
        auditRemark,
        adminAuditRemark,
        orgAuditScoreZhuan,
        auditRemarkZhuan,
        rectificationSuggestion,
      } = row;
      this.downloadViewInfoForClub = {
        targetSecondlyUuid: uuid,
        stageUuid: this.stageUuid,
        youthUuid: this.youthUuid,
        groupUuid: groupUuid,
        orgAuditScore: adminAuditScore,
        targetSecondlyTotalScore: targetSecondlyTotalScore,
        score: score,
        // auditScoreUuid: auditScoreUuid,
        orgAuditScoreUuid: adminAuditScoreUuid,
        youthName: this.youthName,
        isDisabled: isDisabled || false,
        auditRemark: auditRemark,
        adminAuditRemark: adminAuditRemark,
        orgAuditScoreZhuan,
        auditRemarkZhuan,
        rectificationSuggestion,
      };
      this.isShowUploadScore = true;
    },
    // club弹窗信息回调
    handleViewCallBackForClub(flag) {
      if (flag) {
        this.loadPageDetails(true);
      }
      this.isShowUploadScore = false;
    },

    // AuditResult弹窗信息回调
    handleViewCallBackForAuditResult(flag) {
      if (flag) {
        this.loadPageDetails(true);
      }
      this.isShowAdminAuditResult = false;
    },

    // 上传签字确认文件
    handleUploadAuditResult() {
      this.isShowAdminAuditResult = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  /*display flex*/
  width 350px;
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.yioks_btn
  padding: 10px 8px
.content-inner-wrapper
  padding-top 45px
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height auto
        display flex
    .scrollArea
      height 480px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align center
        line-height 1.4em
        color $color_white
.seq
  width 6%
.youthName
  width 20%
.double
  display flex
  flex-direction column
  justify-content center
  align-items center
  p
    text-align center
    width 100%
    white-space pre-line
    // white-space nowrap
    // overflow hidden
    // text-overflow ellipsis
  .suc
    color $green_color !important
.youthShortName
  width 40%
  &.big
    width 45%
  p
    width 100%
    text-align left !important
.submit
  width 10%
.audit
  width 10%
.auditScore
  width 10%
.action
  width 15%
  // flex 1
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.warn
      color $orange_color
  .split
    margin 0 5px
.download-list-wrapper
  padding 0px 20px 20px !important
  .download-item
    font-size 16px
    line-height 1.2em
    margin-bottom 10px
    &:last-child
      margin-bottom 0px
    a
      margin-left 8px
      color $green_color !important
.footer-tips
  height 40px
  padding 0 40px
  display flex
  justify-content flex-end
  align-items center
  font-size 18px
  color red
.action-box
  margin-top 15px
  display flex
  align-items center
  justify-content center
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
<style lang="stylus" scoped>
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
.listBox
  .yioks_audit
    background #F88594

.cursor
  cursor pointer
  user-select none
  color #4cd964 !important
</style>
